type ColorRange = {
  color1: string;
  sep1: number;
  color2: string;
  sep2: number;
  color3: string;
};

type ImbalanceColorConfig = Record<string, ColorRange>;

class ImbalanceColorStore {
  private data: ImbalanceColorConfig = {};

  set(colors: ImbalanceColorConfig) {
    this.data = colors;
  }

  get(): ImbalanceColorConfig {
    return this.data;
  }

  update(key: string, newData: ColorRange) {
    this.data[key] = newData;
  }

  reset() {
    this.data = {};
  }
}

export const imbalanceColorStore = new ImbalanceColorStore();
